function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M0 4.69C0 2.1 2.1 0 4.69 0h38.62C45.9 0 48 2.1 48 4.69v25.588l-12.38-12.38a.828.828 0 00-1.17 0L4.357 47.987A4.69 4.69 0 010 43.31V4.69zm35.035 14.963L48 32.618V43.31C48 45.9 45.9 48 43.31 48H6.687l28.348-28.347zm-24-5.308a3.31 3.31 0 116.62 0 3.31 3.31 0 01-6.62 0zm3.31-4.966a4.966 4.966 0 100 9.931 4.966 4.966 0 000-9.93z"
})));